import React, { memo } from 'react'
import clsx from 'clsx'
import { pick } from 'lodash-es'
import { LoadingOverlay } from '@mantine/core'
import { Button } from '@ow/comps'
import { useTbViewStore } from '@vt/hooks'
import nulldata from '../assets/nulldata.png'
import BindModal from './bindModal'
import UserList from '../../users/selectUserModal/userList'
import StandardTree from '../../standard/selectStandardModal/tree'
import useAreaStore from '../areaStore'

const BindList = function ({ bindInfo, loading }) {
  const clickedInfo = useTbViewStore((state) => state.clickedInfo)
  const { label, clickedId } = clickedInfo
  const { bindedIdsMap, areaBindType } = useAreaStore((state) =>
    pick(state, ['bindedIdsMap', 'areaBindType'])
  )
  const bindedList = bindedIdsMap[clickedId] || []

  let content = null

  if (areaBindType === 'user') {
    content = <UserList userIds={bindedList} />
  } else if (areaBindType === 'standard') {
    content = <StandardTree value={bindedList} />
  }

  return (
    <div className="flex flex-col h-full">
      <LoadingOverlay visible={loading} />
      <div className="flex pb-4 justify-between items-center">
        <span className="text-sm">{label}</span>
        {bindedList.length > 0 && (
          <BindModal>
            <Button type="primary">编辑{bindInfo}</Button>
          </BindModal>
        )}
      </div>
      <div className={clsx(bindedList.length === 0 && 'hidden', 'overflow-auto flex-1')}>{content}</div>
      <div
        className={clsx(
          'flex items-center justify-center',
          bindedList.length > 0 && 'hidden'
        )}
      >
        <div className="flex flex-col gap-6">
          <img
            src={nulldata}
            alt="nulldata"
            style={{ width: '300px', height: '260px' }}
          />
          <div className="text-sm text-center text-neutral-1000">
            暂无绑定的{bindInfo}
          </div>
          <div className="mx-auto">
            <BindModal>
              <Button type="primary">绑定{bindInfo}</Button>
            </BindModal>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(BindList)
